export default {
  'zh_CN': {
    'travel.car.id.label': '主键id',
    'travel.car.id.holder': '请输入主键id',

    'travel.car.id.required': '主键id必填',
    'travel.car.plateNo.label': '车牌号',
    'travel.car.plateNo.holder': '请输入车牌号',
    'travel.car.plateNo.max': '车牌号最多10个字符',

    'travel.car.plateNo.required': '车牌号必填',
    'travel.car.personId.label': '人员id',
    'travel.car.personId.holder': '请输入人员id',
    'travel.car.personId.max': '人员id最多20个字符',

    'travel.car.personId.required': '人员id必填',
    'travel.car.plateType.label': '车牌类型',
    'travel.car.plateType.holder': '请输入车牌类型',

    'travel.car.plateType.required': '车牌类型必填',
    'travel.car.plateColor.label': '车牌颜色',
    'travel.car.plateColor.holder': '请输入车牌颜色',

    'travel.car.plateColor.dictionary': () => [{ value: 0, label: '蓝色' }, { value: 1, label: '黄色' }, {
      value: 2,
      label: '白色'
    }, { value: 255, label: '其他颜色' }, { value: 3, label: '黑色' }, { value: 4, label: '绿色' }, {
      value: 5,
      label: '民航黑色'
    }],
    'travel.car.plateColor.required': '车牌颜色必填',
    'travel.car.vehicleType.label': '车辆类型',
    'travel.car.vehicleType.holder': '请输入车辆类型',

    'travel.car.vehicleType.dictionary': () => [{ value: 0, label: '其他车' }, { value: 1, label: '小型车' }, {
      value: 2,
      label: '大型车'
    }, { value: 3, label: '摩托车' }],
    'travel.car.vehicleType.required': '车辆类型必填',
    'travel.car.vehicleColor.label': '车辆颜色',
    'travel.car.vehicleColor.holder': '请输入车辆颜色',

    'travel.car.vehicleColor.required': '车辆颜色必填',
    'travel.car.vipState.label': '是否会员',
    'travel.car.vipState.holder': '请输入是否会员',

    'travel.car.vipState.dictionary': () => [{ value: 0, label: '否' }, { value: 1, label: '是' }],
    'travel.car.vipState.required': '是否会员必填',
    'travel.car.vipBeginTime.label': 'vip包期开始时间',
    'travel.car.vipBeginTime.holder': '请输入vip包期开始时间',
    'travel.car.vipBeginTime.required': 'vip包期开始时间必填',
    'travel.car.vipEndTime.label': 'vip包期结束时间',
    'travel.car.vipEndTime.holder': '请输入vip包期结束时间',
    'travel.car.vipEndTime.required': 'vip包期结束时间必填',
    'travel.car.description.label': '车辆描述',
    'travel.car.description.holder': '请输入车辆描述',
    'travel.car.description.max': '车辆描述最多20个字符',

    'travel.car.description.required': '车辆描述必填',
    'travel.car.createTime.label': '创建时间',
    'travel.car.createTime.holder': '请输入创建时间',
    'travel.car.createTime.required': '创建时间必填',
    'travel.car.updateTime.label': '更新时间',
    'travel.car.updateTime.holder': '请输入更新时间',
    'travel.car.updateTime.required': '更新时间必填',
    'travel.car.isDelete.label': '是否删除',
    'travel.car.isDelete.holder': '请输入是否删除',

    'travel.car.isDelete.dictionary': () => [{ value: 0, label: '删除' }],
    'travel.car.isDelete.required': '是否删除必填'
  },
  'zh_TW': {
    'travel.car.id.label': '主键id',
    'travel.car.id.holder': '請輸入主键id',

    'travel.car.id.required': '主键id必填',
    'travel.car.plateNo.label': '车牌号',
    'travel.car.plateNo.holder': '請輸入车牌号',

    'travel.car.plateNo.required': '车牌号必填',
    'travel.car.personId.label': '人员id',
    'travel.car.personId.holder': '請輸入人员id',

    'travel.car.personId.required': '人员id必填',
    'travel.car.plateType.label': '车牌类型',
    'travel.car.plateType.holder': '請輸入车牌类型',

    'travel.car.plateType.required': '车牌类型必填',
    'travel.car.plateColor.label': '车牌颜色',
    'travel.car.plateColor.holder': '請輸入车牌颜色',

    'travel.car.plateColor.required': '车牌颜色必填',
    'travel.car.vehicleType.label': '车辆类型',
    'travel.car.vehicleType.holder': '請輸入车辆类型',

    'travel.car.vehicleType.required': '车辆类型必填',
    'travel.car.vehicleColor.label': '车辆颜色',
    'travel.car.vehicleColor.holder': '請輸入车辆颜色',

    'travel.car.vehicleColor.required': '车辆颜色必填',
    'travel.car.vipState.label': '是否会员',
    'travel.car.vipState.holder': '請輸入是否会员',

    'travel.car.vipState.required': '是否会员必填',
    'travel.car.vipBeginTime.label': 'vip包期开始时间',
    'travel.car.vipBeginTime.holder': '請輸入vip包期开始时间',

    'travel.car.vipBeginTime.required': 'vip包期开始时间必填',
    'travel.car.vipEndTime.label': 'vip包期结束时间',
    'travel.car.vipEndTime.holder': '請輸入vip包期结束时间',

    'travel.car.vipEndTime.required': 'vip包期结束时间必填',
    'travel.car.description.label': '车辆描述',
    'travel.car.description.holder': '請輸入车辆描述',

    'travel.car.description.required': '车辆描述必填',
    'travel.car.createTime.label': '创建时间',
    'travel.car.createTime.holder': '請輸入创建时间',

    'travel.car.createTime.required': '创建时间必填',
    'travel.car.updateTime.label': '更新时间',
    'travel.car.updateTime.holder': '請輸入更新时间',

    'travel.car.updateTime.required': '更新时间必填',
    'travel.car.isDelete.label': '是否删除',
    'travel.car.isDelete.holder': '請輸入是否删除',

    'travel.car.isDelete.required': '是否删除必填'
  },
  'en_US': {
    'travel.car.id.label': 'id',
    'travel.car.id.holder': 'Enter id',
    'travel.car.id.max': 'id max length: 主键id',

    'travel.car.id.required': 'id required',
    'travel.car.plateNo.label': 'plateNo',
    'travel.car.plateNo.holder': 'Enter plateNo',
    'travel.car.plateNo.max': 'plateNo max length: 车牌号',

    'travel.car.plateNo.required': 'plateNo required',
    'travel.car.personId.label': 'personId',
    'travel.car.personId.holder': 'Enter personId',
    'travel.car.personId.max': 'personId max length: 人员id',

    'travel.car.personId.required': 'personId required',
    'travel.car.plateType.label': 'plateType',
    'travel.car.plateType.holder': 'Enter plateType',
    'travel.car.plateType.max': 'plateType max length: 车牌类型',

    'travel.car.plateType.required': 'plateType required',
    'travel.car.plateColor.label': 'plateColor',
    'travel.car.plateColor.holder': 'Enter plateColor',
    'travel.car.plateColor.max': 'plateColor max length: 车牌颜色',

    'travel.car.plateColor.required': 'plateColor required',
    'travel.car.vehicleType.label': 'vehicleType',
    'travel.car.vehicleType.holder': 'Enter vehicleType',
    'travel.car.vehicleType.max': 'vehicleType max length: 车辆类型',

    'travel.car.vehicleType.required': 'vehicleType required',
    'travel.car.vehicleColor.label': 'vehicleColor',
    'travel.car.vehicleColor.holder': 'Enter vehicleColor',
    'travel.car.vehicleColor.max': 'vehicleColor max length: 车辆颜色',

    'travel.car.vehicleColor.required': 'vehicleColor required',
    'travel.car.vipState.label': 'vipState',
    'travel.car.vipState.holder': 'Enter vipState',
    'travel.car.vipState.max': 'vipState max length: 是否会员',

    'travel.car.vipState.required': 'vipState required',
    'travel.car.vipBeginTime.label': 'vipBeginTime',
    'travel.car.vipBeginTime.holder': 'Enter vipBeginTime',
    'travel.car.vipBeginTime.max': 'vipBeginTime max length: vip包期开始时间',

    'travel.car.vipBeginTime.required': 'vipBeginTime required',
    'travel.car.vipEndTime.label': 'vipEndTime',
    'travel.car.vipEndTime.holder': 'Enter vipEndTime',
    'travel.car.vipEndTime.max': 'vipEndTime max length: vip包期结束时间',

    'travel.car.vipEndTime.required': 'vipEndTime required',
    'travel.car.description.label': 'description',
    'travel.car.description.holder': 'Enter description',
    'travel.car.description.max': 'description max length: 车辆描述',

    'travel.car.description.required': 'description required',
    'travel.car.createTime.label': 'createTime',
    'travel.car.createTime.holder': 'Enter createTime',
    'travel.car.createTime.max': 'createTime max length: 创建时间',

    'travel.car.createTime.required': 'createTime required',
    'travel.car.updateTime.label': 'updateTime',
    'travel.car.updateTime.holder': 'Enter updateTime',
    'travel.car.updateTime.max': 'updateTime max length: 更新时间',

    'travel.car.updateTime.required': 'updateTime required',
    'travel.car.isDelete.label': 'isDelete',
    'travel.car.isDelete.holder': 'Enter isDelete',
    'travel.car.isDelete.max': 'isDelete max length: 是否删除',

    'travel.car.isDelete.required': 'isDelete required'
  }
}
